import React from "react";
import { Helmet } from "react-helmet-async";

export default function Impressum() {
  return (
    <section className="section-sm">
      <div className="container container-sm prose">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Impressum</title>
      </Helmet>

      <h1>Impressum</h1>
      <p>
        Offenlegung gemäß § 25 Abs. 5 Mediengesetz
      </p>
      <p>
  Diese Website ist ein nicht-kommerzielles, rein privates Hobby- und Studentenprojekt.<br />
  Sie dient ausschließlich der technischen Demonstration eines EDIFACT-Konverters 
  sowie der Information zu technischen Themen. 
  Es bestehen keinerlei wirtschaftliche Interessen oder Absicht zur Beeinflussung der öffentlichen Meinungsbildung.
      </p>
      <p>
        Medieninhaber:<br />
        Johannes Enzensberger<br />
        Wohnort: 4100 Ottensheim, Österreich<br />
        E-Mail: ediconverter.de@gmail.com
      </p>
            <p>
        Unternehmensgegenstand:
        Technische Demonstration und Bereitstellung eines rein clientseitigen Tools zur Konvertierung von EDIFACT-Dateien (z. B. in Excel, CSV, XML, JSON) zu Lern- und Testzwecken.
        Kein kommerzieller Betrieb. Keine Verarbeitung personenbezogener Daten. Keine wirtschaftliche Absicht.      </p>
      </div>
    </section>
  );
}
